import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import SearchMarkdown from '@shieldpay/bumblebee/markdown/search.md';
import { Search } from '@shieldpay/bumblebee/search';
import { Text } from '@shieldpay/bumblebee/text';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { Design } from '~/components/design/design';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.search.title',
});

export const SearchComponentPage = () => {
  const { formatMessage } = useIntl();

  const [searchValue, setSearchValue] = useState('');

  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.search.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview>
        <Search
          name="someSearchBox"
          onChange={(value) => setSearchValue(value)}
          onClear={() => setSearchValue('')}
          clearLabel={formatMessage({
            id: 'hive.components.search.clearLabel',
          })}
          label={formatMessage({
            id: 'hive.components.search.label',
          })}
          placeholder={formatMessage({
            id: 'hive.components.search.placeholder',
          })}
          value={searchValue}
        />
      </ComponentPreview>

      <Design>
        <Design.Section heading="Usage">
          <Text paragraph>
            Search input allows users to search for specific content.
          </Text>
        </Design.Section>
        <Design.Section heading="Anatomy">
          <Text paragraph>
            Search should be placed next to the filters to allow searching for
            specific content. Please refer to Placement in page designs for
            examples.
          </Text>
        </Design.Section>
        <Design.Section heading="Placement">
          <Text paragraph>
            The state of the form field changes depending on the actions of the
            user. The structure of how the instances behave are outlined, right.
          </Text>
          <Text paragraph>
            Transition to display a state change with a 0.25 ease.
          </Text>
        </Design.Section>
        <Design.Section heading="Accessibility">
          <Text paragraph>
            Use the appropriate ARIA attributes for screen readers where
            applicable. Users should be able to TAB into the input field of the
            search box to begin typing and press ENTER to run the search query.
          </Text>
        </Design.Section>
      </Design>

      <MdxFormatter md={SearchMarkdown} />
    </>
  );
};

export default SearchComponentPage;
